import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import ProductsPage from './pages/ProductsPage';
import ApartmentsPage from './pages/ApartmentsPage';
import ApartmentDetail from './pages/ApartmentDetail';
import CustomersPage from './pages/CustomersPage';
import CounterSalesPage from './pages/CounterSalesPage';
import OrdersPage from './pages/OrdersPage';
import OrderDetail from './pages/OrderDetail';
import StaffPage from './pages/StaffPage';
import VehiclesPage from './pages/VehiclesPage';
import InventoryPage from './pages/InventoryPage';
import AttendancePage from './pages/AttendancePage';
import SalaryPage from './pages/SalaryPage';
import FinancePage from './pages/FinancePage';

const ProtectedRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="flex-center" style={{ height: '100vh' }}>
      <div className="spinner"></div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

const AppRoutes = () => {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={
          <ProtectedRoute>
            {user?.role === 'STF' ? <Navigate to="/orders" replace /> : <Dashboard />}
          </ProtectedRoute>
        } />
        <Route path="products" element={<ProtectedRoute roles={['ADM','MGR']}><ProductsPage /></ProtectedRoute>} />
        <Route path="inventory" element={<ProtectedRoute roles={['ADM','MGR']}><InventoryPage /></ProtectedRoute>} />
        <Route path="apartments" element={<ApartmentsPage />} />
        <Route path="apartments/:id" element={<ApartmentDetail />} />
        <Route path="customers" element={<CustomersPage />} />
        <Route path="counter-sales" element={<ProtectedRoute roles={['ADM','MGR']}><CounterSalesPage /></ProtectedRoute>} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="orders/:id" element={<OrderDetail />} />
        <Route path="staff" element={<ProtectedRoute roles={['ADM','MGR']}><StaffPage /></ProtectedRoute>} />
        <Route path="vehicles" element={<ProtectedRoute roles={['ADM','MGR']}><VehiclesPage /></ProtectedRoute>} />
        <Route path="attendance" element={<ProtectedRoute roles={['ADM','MGR']}><AttendancePage /></ProtectedRoute>} />
        <Route path="salary" element={<ProtectedRoute roles={['ADM','MGR']}><SalaryPage /></ProtectedRoute>} />
        <Route path="finance" element={<ProtectedRoute roles={['ADM','MGR']}><FinancePage /></ProtectedRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

const App = () => (
  <BrowserRouter>
    <AuthProvider>
      <ToastProvider>
        <AppRoutes />
      </ToastProvider>
    </AuthProvider>
  </BrowserRouter>
);

export default App;
